import { aiConversations, aiMessages } from '../aiConversation'
import { describeTable } from './describeTable'

describeTable(aiConversations, {
  aiAccess: 'denied',
  description:
    'A thread between a management user and the AI data analyst (this assistant). One row per thread, readable by all of management; only the asker can continue or delete it. The questions and answers are in ai_messages.',
  columns: {
    userId: 'Who asked.',
    title: 'First question, truncated.',
  },
})

describeTable(aiMessages, {
  aiAccess: 'denied',
  description:
    'Questions (role user) and answers (role assistant) of an AI analyst thread. steps holds every SQL query the assistant ran for the answer, so this table is also the audit log of what the assistant read.',
  columns: {
    status:
      'pending = queued, running = being answered, done, failed (see error), cancelled = stopped by the asker.',
    steps:
      "JSON array of tool calls: {type:'sql', purpose, sql, rows, truncated, durationMs, error?}, {type:'describe', tables}, {type:'chart', spec}, {type:'excel', title, sql, columns}, {type:'suggestions', questions}, {type:'notice', code, text, detail?, at} for retries and failures.",
    usage: 'Token counts and model rounds spent on the answer.',
    durationMs: 'Wall-clock time from pickup to final answer.',
  },
})
